<template>
  <div class="profile">
    <div class="view-content">
      <div class="columns is-multiline is-variable is-full">
        <div class="column is-half">
          <div class="box" :class="{short : !show.details}">
            <div class="columns">
              <div class="column is-12">
                <div class="container__sub-title is-full" @click="toggleMinimise('details')">
                  <h1 class="title is-4">My Company Details</h1>
                  <!--                  <div class="edit">-->
                  <!--                    <fa icon="pencil" size="1x" :style="{color: '#fff'}"></fa>-->
                  <!--                  </div>-->
                  <div v-if="deviceIsMobile" class="minimise">
                    <fa :icon="show.details ? 'chevron-down' : 'chevron-right'" size="1x" :style="{color: '#fff'}"></fa>
                  </div>
                </div>
                <div v-if="show.details" class="content">
                  <div class="column">
                    <div class="box short white">
                      <div class="columns">
                        <div class="column is-3">
                          <p class="has-text-weight-bold is-size-6">Name</p>
                        </div>
                        <div class="column is-9 has-text-right">
                          <p>{{ company.name }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="box short white">
                      <div class="columns">
                        <div class="column" :class="{'is-6' : deviceIsMobile, 'is-5': !deviceIsMobile  }">
                          <p class="has-text-weight-bold is-size-6">Address</p>
                        </div>
                        <div class="column address-column"
                             :class="{'is-6' : deviceIsMobile, 'is-7': !deviceIsMobile  }">
                          <p v-if="company.address.line1" class="has-text-left">{{ company.address.line1 }}</p>
                          <p v-if="company.address.line2" class="has-text-left">{{ company.address.line2 }}</p>
                          <p v-if="company.address.town" class="has-text-left">{{ company.address.town }}</p>
                          <p v-if="company.address.postcode" class="has-text-left">{{ company.address.postcode }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half hide-on-mobile">
          <div class="slider-container box">
            <ad-carousel></ad-carousel>
          </div>
        </div>
        <div class="column is-half">
          <div class="box" :class="{short : !show.contacts}">
            <div class="columns">
              <div class="column is-12">
                <div class="container__sub-title is-full" @click="toggleMinimise('contacts')">
                  <h1 class="title is-4">My Company Contacts</h1>
                  <!--                  <div class="edit">-->
                  <!--                    <fa icon="pencil" size="1x" :style="{color: '#fff'}"></fa>-->
                  <!--                  </div>-->
                  <div v-if="deviceIsMobile" class="minimise">
                    <fa :icon="show.contacts ? 'chevron-down' : 'chevron-right'" size="1x"
                        :style="{color: '#fff'}"></fa>
                  </div>
                </div>
                <div v-if="show.contacts" class="content">
                  <div class="column">
                    <div v-for="contact in contacts" class="box short white is-12">
                      <div class="column">
                        <div class="columns">
                          <div class="column is-4">
                            <p class="has-text-weight-bold is-size-6">{{ contact.name | title }}</p>
                          </div>
                          <div class="column is-8">
                            <div v-for="(telephone, index) in contact.telephones">
                              <p class="telephone"> {{ telephone }}<span v-if="index < contact.length - 1"></span>
                              </p>
                            </div>
                            <div v-for="email in contact.emails">
                              <p class="email">{{ email }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class="box" :class="{short : !show.services}">
            <div class="columns">
              <div class="column is-12">
                <div class="container__sub-title is-full" @click="toggleMinimise('services')">
                  <h1 class="title is-4">My Active Services</h1>
                  <!--                  <div class="edit">-->
                  <!--                    <fa icon="pencil" size="1x" :style="{color: '#fff'}"></fa>-->
                  <!--                  </div>-->
                  <div v-if="deviceIsMobile" class="minimise">
                    <fa :icon="show.services ? 'chevron-down' : 'chevron-right'" size="1x"
                        :style="{color: '#fff'}"></fa>
                  </div>
                </div>
                <div v-if="show.services" class="content">
                  <div class="column">
                    <div v-for="service in services" class="box short white is-12">
                      <div class="column">
                        <div class="columns">
                          <div class="column is-6">
                            <p class="has-text-weight-bold is-size-6">{{ service.product.name | title }}</p>
                          </div>
                          <div class="column is-6">
                            <div class="columns is-12">
                              <div class="column is-6">
                                <p class="has-text-weight-bold is-size-6">Status</p>
                                <p>{{ getServiceState(service) | title }}</p>
                              </div>
                              <div class="column is-6">
                                <p class="has-text-weight-bold is-size-6">Expires</p>
                                <p>{{ getServiceExpiry(service) }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class="box" :class="{short : !show.markUps}">
            <div class="columns">
              <div class="column is-12">
                <div class="container__sub-title is-full" @click="toggleMinimise('markUps')">
                  <h1 class="title is-4">My Mark-Ups</h1>
                  <!--                  <div class="edit">-->
                  <!--                    <fa icon="pencil" size="1x" :style="{color: '#fff'}"></fa>-->
                  <!--                  </div>-->
                  <div v-if="deviceIsMobile" class="minimise">
                    <fa :icon="show.markUps ? 'chevron-down' : 'chevron-right'" size="1x" :style="{color: '#fff'}"></fa>
                  </div>
                </div>
                <div v-if="show.markUps" class="content">
                  <div class="column">
                    <div v-for="(markUp,key) in markUps" class="is-12 box short white">
                      <div class="columns">
                        <div class="column is-6">
                          <div class="has-text-weight-bold has-text-left">{{ key | title }}</div>
                        </div>
                        <div class="column is-6">
                          <div class="has-text-right">{{ markUp | percentage }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class="box" :class="{short : !show.labourRates}">
            <div class="columns">
              <div class="column is-12">
                <div class="container__sub-title is-full" @click="toggleMinimise('labourRates')">
                  <h1 class="title is-4">My Labour Rates <span id="perHourFont">(per hour)</span></h1>
                  <!--                  <div class="edit">-->
                  <!--                    <fa icon="pencil" size="1x" :style="{color: '#fff'}"></fa>-->
                  <!--                  </div>-->
                  <div v-if="deviceIsMobile" class="minimise">
                    <fa :icon="show.labourRates ? 'chevron-down' : 'chevron-right'" size="1x"
                        :style="{color: '#fff'}"></fa>
                  </div>
                </div>
                <div v-if="show.labourRates" class="content">
                  <div class="column">
                    <div v-for="(labourRate ,key) in labourRates" class="is-12 box short white">
                      <div class="columns">
                        <div class="column is-6">
                          <div class="has-text-weight-bold has-text-left">{{ key | title }}</div>
                        </div>
                        <div class="column is-6">
                          <div class="has-text-right">{{ labourRate | currencyNotReduced }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filters from 'module/filters';
import store from 'module/store';

import {VueperSlides, VueperSlide} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import AdCarousel from "../../../../../resource/component/ad-carousel/component.vue";

const moment = require('moment');

export default {
  name: "profile-view",
  beforeRouteEnter(to, from, next) {
    if (store.state.company.selected.company) {
      next();
    } else {
      next({name: 'overview'});
    }
  },
  filters,
  components: {
    AdCarousel,
    VueperSlides,
    VueperSlide,
  },
  created() {
    this.$store.commit('generic/showSearchBar', false);
    this.$store.dispatch('company/clearFilteredProjects');
  },
  data() {
    return {
      isComponentModalActive: false,
      acknowledgeCheckBox: false,
      editButtonColor: '#11458C',
      show: {
        details: false,
        contacts: false,
        services: false,
        markUps: false,
        labourRates: false,
      },
      slides: [
        {
          title: 'Slide #1',
          content: 'Slide 1 content.'
        },
        {
          title: 'Slide #2',
          content: 'Slide 2 content.'
        },
        {
          title: 'Slide #3',
          content: 'Slide 3 content.'
        },
        {
          title: 'Slide #4',
          content: 'Slide 4 content.'
        }
      ],
    }
  },
  computed: {
    deviceIsMobile() {
      return this.$store.state.device.type === 'mobile';
    },
    company() {
      return this.$store.state.company.selected.company;
    },
    contacts() {
      return _.get(this.company, 'contacts', []).filter(contact => (contact.telephones.length > 0 || contact.email !== null) && contact.isDeleted !== true);
    },
    labourRates() {
      return _.get(this.company, 'preferences.form.labourRates', []);
    },
    isExternalUser() {
      return this.$store.getters['user/isExternalCompany'];
    },
    markUps() {
      return _.get(this.company, 'preferences.form.markUp', []);
    },
    services() {
      let services = _.get(this.company, 'sales', []);
      services = services.filter(sale => {
        return this.getServiceState(sale) !== 'expired' &&
          this.getServiceState(sale) !== 'N/A' &&
          this.getServiceExpiry(sale) &&
          this.getServiceExpiry(sale) !== 'N/A';
      });

      return services;
    },
  },
  mounted() {
    if (!this.deviceIsMobile) {
      this.show = {
        details: true,
        contacts: true,
        services: true,
        markUps: true,
        labourRates: true,
      };
    }
  },
  watch: {
    deviceIsMobile(newValue) {
      if (!newValue) {
        this.show = {
          details: true,
          contacts: true,
          services: true,
          markUps: true,
          labourRates: true,
        };
      } else {
        this.show = {
          details: false,
          contacts: false,
          services: false,
          markUps: false,
          labourRates: false,
        };
      }
    }
  },
  methods: {
    getServiceState(service) {
      const expiryDate = filters.momentDate(_.get(service, 'expiry', null));

      if (expiryDate && expiryDate.isBefore(moment())) {
        return 'expired';
      } else if (expiryDate) {
        return 'active';
      } else {
        return 'N/A';
      }
    },
    getServiceExpiry(service) {
      const expiryDate = filters.momentDate(_.get(service, 'expiry', null));

      if (expiryDate && expiryDate.isBefore(moment())) {
        return 'N/A';
      } else if (expiryDate) {
        return filters.date(expiryDate);
      } else {
        return null;
      }
    },

    openModal() {
      this.isComponentModalActive = true;
    },
    closeMethod() {
      this.isComponentModalActive = false;
    },
    removeUserDataClickButton() {
      this.$store.dispatch('company/requestToRemoveData',
        this.company
      ).then(() => {
        this.loading = false;
        this.edit = false;
      })
      this.closeMethod();
      this.acknowledgeCheckBox=false;
    },
    toggleMinimise(section) {
      if (this.deviceIsMobile) {
        this.show[section] = !this.show[section];
      }
    },
  }
}
</script>


<style scoped lang="scss">
.profile {
  height: 100%;
  width: 100%;
  background-color: whitesmoke;

  .view-content {
    margin-top: 2em;
    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      margin-top: 1.5rem;
    }

    .columns {
      flex-grow: 1;
    }
  }

  .slider-container {
    min-height: 366px;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.2), 0 0px 0 1px rgba(10, 10, 10, 0.04);
  }

  .vueperslides {
    height: 100%;
    flex-grow: 1;
    box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.2), 0 0px 0 1px rgba(10, 10, 10, 0.04);
  }

  .vueperslides__inner {
    height: 100%;
  }

  .vueperslides__track {
    height: 100%;
  }

  .vueperslides__parallax-wrapper {
    height: 100%;
  }

  .box {
    height: 100%;
  }

  .removeDataButton {
    display: flex;
    justify-content: flex-end;
  }

  .removeUserDataButton {
    border: 1px solid hsl(0, 0%, 29%);
    margin-top: 5rem;
    background-color: #ffd600;
    color: hsl(0, 0%, 29%);
  }

  .insideModal {
    filter: brightness(100%);
    width: 500px;
    height: 340px;
    border: 2px solid #ffd600;
    border-radius: 30px;
    background-color: #11458c;
  }

  .modalHeader {
    text-align: center;
    margin-top: 20px;

  }

  .modalHeader h2 {
    color: #f6f8fb;
  }

  .modalHeader h1 {
    color: red;
  }

  .modalText {
    padding-left: 40px;
    padding-right: 40px;
    color: #f6f8fb;
  }

  .modalCheckbox {
    color: #f6f8fb;
    padding-left: 15px;
    padding-right: 30px;
    margin-left: 2rem;
  }

  .modalsButtonDiv {
    margin-top: 20px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modalButton {
    background-color:#ffd600 ;
    color: hsl(0, 0%, 29%);
    text-align: center;
    margin-bottom: 50px;
  }

  #perHourFont {
    font-size: .90rem;
  }

  .container__sub-title {
    display: grid;
    justify-content: flex-start;
    align-items: center;
    gap: 2px;
    grid-template-columns: 4fr 1fr;

    .edit {
      &:hover {
        cursor: pointer;
      }
    }

    .minimise {
      align-self: flex-start !important;
      justify-self: flex-end !important;

      &:hover {
        cursor: pointer;
      }
    }
  }
}

@media (max-width: 767px) {
  #insideModalMobile {
    filter: brightness(100%);
    width: 400px;
    height: 350px;
    border: 2px solid #ffd600;
    border-radius: 30px;
    background-color: #11458c;
  }

  #modalButtonMobile {
    background-color:#ffd600 ;
    color: hsl(0, 0%, 29%);
    text-align: center;
  }
}
</style>